module.exports = __webpack_public_path__ + "img/nenhuma-compra.94607338.svg";